// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_status__7Ung2{
    display: flex;
    align-items: center;
    justify-content: center;
}

.styles_assinado__UqAqR{
    background-color: green;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: .5rem;
    width: 0.7rem;
}

.styles_pendente__IhyMe{
    background-color: orange;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: .5rem;
    width: 0.7rem;

}

.styles_cancelado__e-ibx{
    background-color: red;
    border-radius: 50%;
    height: 0.7rem;
    margin-right: .5rem;
    width: 0.7rem;

}

.styles_prazo__BbPC0{
    background-color: rgb(158, 5, 5);
    border-radius: 50%;
    height: 0.7rem;
    margin-right: .5rem;
    width: 0.7rem;
}

.styles_content_cancel__tWK1p{
    color: #18316e;
    font-size: 1.1rem;
    text-align: center;

}

.styles_conteinerBtnCancel__VRePY{
    display: flex;
    margin-top: 2rem;
    justify-content: space-between;
}

.styles_conteinerBtnAlterar__mWqdF{
    display: flex;
    margin-top: 2rem;
    justify-content: space-between;
    size: large;
    
}

.styles_content_alterar__gCHbS{
    color: #18316e;
    font-size: 1rem;
    text-align: center;
    margin-bottom: 1.5rem;

}

.styles_conteinerBtnSignatarios__MLift{
    display: flex;
    margin: .5rem 1rem 1rem 1rem;
    justify-content: space-between;
    size: large;
}

.styles_titleSignatarios__FKuPe{
    align-items: center;
    display: flex;
    font-weight: bold;
    margin: 1rem 0 0 1rem;
    text-align: left;
}

.styles_listSignatarios__x32hq{
    border-bottom: 1px solid #c2c2c2;
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Contratos/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;;AAEjB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;;AAEf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB","sourcesContent":[".status{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.assinado{\n    background-color: green;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: .5rem;\n    width: 0.7rem;\n}\n\n.pendente{\n    background-color: orange;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: .5rem;\n    width: 0.7rem;\n\n}\n\n.cancelado{\n    background-color: red;\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: .5rem;\n    width: 0.7rem;\n\n}\n\n.prazo{\n    background-color: rgb(158, 5, 5);\n    border-radius: 50%;\n    height: 0.7rem;\n    margin-right: .5rem;\n    width: 0.7rem;\n}\n\n.content_cancel{\n    color: #18316e;\n    font-size: 1.1rem;\n    text-align: center;\n\n}\n\n.conteinerBtnCancel{\n    display: flex;\n    margin-top: 2rem;\n    justify-content: space-between;\n}\n\n.conteinerBtnAlterar{\n    display: flex;\n    margin-top: 2rem;\n    justify-content: space-between;\n    size: large;\n    \n}\n\n.content_alterar{\n    color: #18316e;\n    font-size: 1rem;\n    text-align: center;\n    margin-bottom: 1.5rem;\n\n}\n\n.conteinerBtnSignatarios{\n    display: flex;\n    margin: .5rem 1rem 1rem 1rem;\n    justify-content: space-between;\n    size: large;\n}\n\n.titleSignatarios{\n    align-items: center;\n    display: flex;\n    font-weight: bold;\n    margin: 1rem 0 0 1rem;\n    text-align: left;\n}\n\n.listSignatarios{\n    border-bottom: 1px solid #c2c2c2;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `styles_status__7Ung2`,
	"assinado": `styles_assinado__UqAqR`,
	"pendente": `styles_pendente__IhyMe`,
	"cancelado": `styles_cancelado__e-ibx`,
	"prazo": `styles_prazo__BbPC0`,
	"content_cancel": `styles_content_cancel__tWK1p`,
	"conteinerBtnCancel": `styles_conteinerBtnCancel__VRePY`,
	"conteinerBtnAlterar": `styles_conteinerBtnAlterar__mWqdF`,
	"content_alterar": `styles_content_alterar__gCHbS`,
	"conteinerBtnSignatarios": `styles_conteinerBtnSignatarios__MLift`,
	"titleSignatarios": `styles_titleSignatarios__FKuPe`,
	"listSignatarios": `styles_listSignatarios__x32hq`
};
export default ___CSS_LOADER_EXPORT___;
